import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Canonical-domain redirect runs at HTML parse time from public/index.html —
// before any JS bundle loads. Keeping this file free of the redirect avoids
// double-running the check after React has already booted.

// Static head tags are for crawlers that don't run JS; each page sets its own once the app loads
document.querySelectorAll("[data-static-seo]").forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

